import { useEffect } from "react";
import { Box } from "@mui/material";

export default function GoogleTranslate({ sx, ...boxProps }) {
  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    addScript.async = true;
    document.body.appendChild(addScript);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout:
            window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          autoDisplay: false,
        },
        "google_translate_element",
      );
    };

    return () => {
      document.body.removeChild(addScript);
    };
  }, []);

  return (
    <Box
      sx={[
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          "& .goog-te-combo": {
            height: "32px",
            borderRadius: "6px",
            padding: "4px",
          },
        },
        sx,
      ]}
      {...boxProps}
    >
      <Box id="google_translate_element" />
    </Box>
  );
}